import {useTranslation} from "react-i18next";
import {Table} from "react-bootstrap";

const TableWarnings = (props) => {
    const {t: _Tt} = useTranslation("tables");

    return (
        <div className="col-12 mt-3">
            <h3 className="text-warning text-center">{_Tt("labels.warnings")}</h3>
            <Table striped bordered responsive>
                <thead>
                    <tr>
                        <th style={{width: "60px"}}>{_Tt("common.line")}</th>
                        <th style={{width: "220px"}}>{_Tt("common.active")}</th>
                        <th>{_Tt("common.message")}</th>
                    </tr>
                </thead>
                <tbody className="text-warning">
                    {props.items.map((item, index) => (
                        <tr key={index} data-idx={index}>
                            <td>{item.line}</td>
                            <td>{item.active}</td>
                            <td>{item.message}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TableWarnings;
